var render = function () {
  var _this$selectedBranch, _this$selectedBranch2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb')], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-2 mb-1 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isBranchProductList ? '分店商品列表' : '商品管理') + " ")]), _c('div', {
    staticClass: "\n            col-12 col-xl-10\n            d-flex\n            flex-column flex-xl-row\n            align-items-start align-items-xl-center justify-content-xl-end\n          "
  }, [!_vm.isBranchProductList && _vm.checkPermission([_vm.consts.BRANCH_PRODUCT_SYNC]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSyncAllBranchProduct
    }
  }, [_c('i', {
    staticClass: "mdi mdi-sync",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("同步所有商品至分店 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PRODUCT_IMPORT]) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-upload",
      modifiers: {
        "modal-upload": true
      }
    }],
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2",
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-cloud-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("商品匯入 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PRODUCT_IMPORT_MICHELIN]) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-upload-michelin",
      modifiers: {
        "modal-upload-michelin": true
      }
    }],
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2",
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-cloud-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("商品匯入 - 米其林 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PRODUCT_IMPORT_MICHELIN_MB]) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-upload-michelin-mb",
      modifiers: {
        "modal-upload-michelin-mb": true
      }
    }],
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2",
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-cloud-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("商品匯入 - 米其林 - MB ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PRODUCT_CREATE]) && !_vm.isBranchProductList ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'ProductCreateV2',
        query: {
          merchant_id: this.query.merchant_id,
          is_branch_product: _vm.isBranchProductList
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("新增商品 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.BRANCH_PRODUCT_CREATE]) && _vm.isBranchProductList ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'ProductCreateV2',
        query: {
          merchant_id: this.query.merchant_id,
          branch_id: ((_this$selectedBranch = this.selectedBranch) === null || _this$selectedBranch === void 0 ? void 0 : _this$selectedBranch.value) === 'null' ? null : (_this$selectedBranch2 = this.selectedBranch) === null || _this$selectedBranch2 === void 0 ? void 0 : _this$selectedBranch2.value,
          is_branch_product: _vm.isBranchProductList
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("新增分店商品 ")]) : _vm._e(), _vm.isBranchProductList && _vm.checkPermission([_vm.consts.BRANCH_PRODUCT_SINGLE_SYNC]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSyncProductFromMain
    }
  }, [_c('i', {
    staticClass: "fa fa-rotate-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("同步商品 ")]) : _vm._e(), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-advanced-search",
      modifiers: {
        "collapse-advanced-search": true
      }
    }],
    staticClass: "mb-2 mb-xl-0",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "variant": "outline-info"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-magnify mt-1 mr-1"
  }), _vm._v("進階搜尋 ")])], 1), _c('div', {
    staticClass: "col-12 mt-2"
  }, [_c('b-collapse', {
    attrs: {
      "id": "collapse-advanced-search"
    },
    model: {
      value: _vm.isAdvancedSearchVisible,
      callback: function callback($$v) {
        _vm.isAdvancedSearchVisible = $$v;
      },
      expression: "isAdvancedSearchVisible"
    }
  }, [_c('b-card', [_c('b-form', [_c('div', {
    staticClass: "row mb-2"
  }, [_vm.isBranchProductList ? _c('div', {
    staticClass: "col-12 col-xl-6 mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "filter-label mb-0 mr-2"
  }, [_vm._v("分店")]), _c('AppSingleSelect', {
    staticClass: "advanced-search-control flex-grow-1",
    attrs: {
      "id": "branch-select",
      "options": _vm.branchOptions,
      "disabled": _vm.isBranchSelectDisabled
    },
    model: {
      value: _vm.selectedBranch,
      callback: function callback($$v) {
        _vm.selectedBranch = $$v;
      },
      expression: "selectedBranch"
    }
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "col-12 col-xl-6 mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "filter-label mb-0 mr-2"
  }, [_vm._v("類型")]), _c('b-form-select', {
    staticClass: "advanced-search-control flex-grow-1",
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("全部類型")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.query.type,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "type", $$v);
      },
      expression: "query.type"
    }
  }, _vm._l(_vm.productTypes, function (productType) {
    return _c('b-form-select-option', {
      key: productType.value,
      attrs: {
        "value": productType.value
      }
    }, [_vm._v(" " + _vm._s(productType.text) + " ")]);
  }), 1)], 1)]), _c('div', {
    staticClass: "col-12 col-xl-6 mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "filter-label mb-0 mr-2"
  }, [_vm._v("分類")]), _c('b-form-select', {
    staticClass: "advanced-search-control flex-grow-1",
    attrs: {
      "options": _vm.productCategoryOptions
    },
    model: {
      value: _vm.query.category,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "category", $$v);
      },
      expression: "query.category"
    }
  })], 1)]), _c('div', {
    staticClass: "col-12 col-xl-6 mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "filter-label mb-0 mr-2"
  }, [_vm._v("狀態")]), _c('b-form-select', {
    staticClass: "advanced-search-control flex-grow-1",
    attrs: {
      "options": _vm.productStatusOptions
    },
    model: {
      value: _vm.query.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "is_enabled", $$v);
      },
      expression: "query.is_enabled"
    }
  })], 1)]), _c('div', {
    staticClass: "col-12 col-xl-6 mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "filter-label mb-0 mr-2"
  }, [_vm._v("通路")]), _c('b-form-select', {
    staticClass: "advanced-search-control flex-grow-1",
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.merchants.length == 2
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  })], 1)])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.resetAdvancedSearch
    }
  }, [_c('i', {
    staticClass: "mdi mdi-restart"
  }), _vm._v(" 重置條件 ")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSearchFromAdvanced
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" 搜尋 ")])], 1)])], 1)], 1)], 1), _c('div', {
    staticClass: "col-12 mt-2"
  }, [_c('b-card', {
    staticClass: "mb-0"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入商品名稱或商品序號"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFiltersAreChanged.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handleFiltersAreChanged
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)], 1)]), _c('b-table', {
    staticClass: "product-list-table",
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.products,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProductDetailV2',
              params: {
                product_id: data.item.id
              }
            }
          }
        }, [_c('div', {
          staticClass: "mb-1 text-truncate-cell",
          attrs: {
            "id": "product-title-".concat(data.item.id)
          }
        }, [_vm._v(" " + _vm._s(_vm.hiddenString(data.item.title, 50)) + " ")]), data.item.title ? _c('b-popover', {
          attrs: {
            "target": "product-title-".concat(data.item.id),
            "triggers": "hover focus",
            "placement": "right"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(data.item.title))])]) : _vm._e(), _c('div', {
          staticClass: "text-truncate-cell",
          attrs: {
            "id": "product-code-".concat(data.item.id)
          }
        }, [_vm._v(" " + _vm._s(_vm.hiddenString(data.item.product_code, 50)) + " ")]), data.item.product_code ? _c('b-popover', {
          attrs: {
            "target": "product-code-".concat(data.item.id),
            "triggers": "hover focus",
            "placement": "right"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(data.item.product_code))])]) : _vm._e()], 1)];
      }
    }, {
      key: "cell(picture)",
      fn: function fn(data) {
        return [data.item.images[0] && data.item.images[0].pic_url ? _c('b-img-lazy', {
          staticClass: "thumb-image",
          attrs: {
            "src": data.item.images[0] && data.item.images[0].pic_url,
            "alt": "商品圖片",
            "width": "50",
            "height": "50"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(started_at_and_end_at)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "mb-1"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(data.item.available_start_at)) + " ")]), _c('div', [_vm._v(_vm._s(_vm.formatDate(data.item.available_end_at)))])];
      }
    }, {
      key: "cell(type)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.getProductTypeText(data.item.type)) + " ")];
      }
    }, {
      key: "cell(arrange)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.PRODUCT_LIST_VIEW]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'ProductDetailV2',
              params: {
                product_id: data.item.id
              },
              query: {
                is_branch_product: _vm.isBranchProductList
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye mr-1"
        }), _vm._v("查看 ")]) : _vm._e(), (_vm.isBranchProductList ? _vm.checkPermission([_vm.consts.BRANCH_PRODUCT_MODIFY]) : _vm.checkPermission([_vm.consts.PRODUCT_MODIFY]) || _vm.checkPermission([_vm.consts.PRODUCT_STOCK_MODIFY])) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'ProductEditV2',
              params: {
                product_id: data.item.id
              },
              query: {
                is_branch_product: _vm.isBranchProductList
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil mr-1"
        }), _vm._v("編輯 ")]) : _vm._e(), (_vm.isBranchProductList ? _vm.checkPermission([_vm.consts.BRANCH_PRODUCT_DELETE]) : _vm.checkPermission([_vm.consts.PRODUCT_DELETE])) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.handleDelete(data.item.id);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete mr-1"
        }), _vm._v("刪除 ")]) : _vm._e(), _c('b-dropdown', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-secondary"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "mdi mdi-menu"
        })]), _vm.checkPermission([_vm.consts.PRODUCT_IMAGE_MODIFY]) ? _c('b-dropdown-item', {
          staticClass: "ml-2",
          attrs: {
            "to": {
              name: 'ProductUpdateImage',
              params: {
                product_id: data.item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "mdi mdi-image-multiple"
        }), _vm._v("設定圖片 ")]) : _vm._e(), !_vm.isBranchProductList && _vm.checkPermission([_vm.consts.BRANCH_PRODUCT_SYNC]) ? _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.handleSyncOneProductToBranch(data.item.id);
            }
          }
        }, [_c('i', {
          staticClass: "mdi mdi-sync",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("同步至所有分店 ")]) : _vm._e()], 2)];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-upload",
      "title": "批次上傳"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              return _vm.getSampleExcelFile(null, '/excel/product_list.xlsx');
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text"
        }), _vm._v("下載範例檔案")]), _c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")])];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("選擇通路")]), _c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": ""
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v(" 請上傳帳號 Excel 檔案 ")]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.uploadProduct
    }
  })], 1)])], 1), _c('b-modal', {
    attrs: {
      "id": "modal-upload-michelin",
      "title": "批次上傳 - 米其林"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var cancel = _ref2.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")])];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUploadMichelin
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("選擇通路")]), _c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": ""
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v(" 請上傳商品 Excel 檔案 ")]), _c('b-form-file', {
    ref: "fileInputMichelin",
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.uploadProductMichelin
    }
  })], 1)])], 1), _c('b-modal', {
    attrs: {
      "id": "modal-upload-michelin-mb",
      "title": "批次上傳 - 米其林 - MB"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref3) {
        var cancel = _ref3.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")])];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUploadMichelinMb
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("選擇通路")]), _c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": ""
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v(" 請上傳商品 Excel 檔案 ")]), _c('b-form-file', {
    ref: "fileInputMichelinMb",
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.uploadProductMichelinMb
    }
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }